import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadService } from 'src/app/services/load.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-load',
  templateUrl: './load.page.html',
  styleUrls: ['./load.page.scss'],
})
export class LoadPage implements OnInit {
  public file: File = undefined;
  public fileName: string = ''
  public errors: any[] = [];
  public uploaded: any[] = [];
  public type: string = undefined;
  public typeFile: string = 'zip';
  public typeUpload: string = 'succesfully';

  constructor(
    private uiSv: UiServices,
    private loadSv: LoadService,
    private trSv: TranslateService
  ) { }

  ngOnInit() {
  }

  async uploadFile(ev){
    const file: File = ev.target.files[0];
    const msg = this.typeFile === 'zip' ? 'zip' : 'excel';
    if(file.name.includes('.zip') || file.name.includes('.csv') || file.name.includes('.xlsx')){
      this.file = file;
      this.fileName = this.file.name;
    }else{
      const tr = this.trSv.instant('SUBE_UN_ARCHIVO');
      const trV = this.trSv.instant('VALIDO');
      await this.uiSv.showToast(`${tr} ${msg} ${trV}`);
    }
    ev.target.value = null;
  }

  setValue(ev){
    this.type = ev.detail.value;
  }

  setType(ev){
    this.typeUpload = ev.detail.value;
  }

  async save(){
    let route = '';
    let msgErr = '';
    if(this.typeFile === 'zip'){
      route = 'masiveImage';
      msgErr = '.zip'
    }else{
      route = 'masiveCsv';
      msgErr = '.csv'
    }
    if(!this.file){
      return await this.uiSv.showToast(`Sube un archivo ${msgErr} antes de continuar`);
    }
    if(!this.type){
      return await this.uiSv.showToast('Selecciona un tipo de carga antes de continuar');
    }
    if(this.typeFile === 'excel'){
      this.loadSv.uploadData.emit();
      return true;
    }
    const { errors, uploaded } = await this.loadSv.uploadZip(this.file, route, this.type);
    this.errors = errors;
    this.uploaded = uploaded;
    this.fileName = '';
    this.file = undefined;
  }

  async sendExcel(ev){
    try{
      ev.file = this.file;
      await this.loadSv.uploadExcel(ev);
      delete ev.file;
      const excelOrden = JSON.stringify(ev);
      localStorage.setItem('excel', excelOrden);
      this.fileName = '';
      this.file = undefined;
    }catch(err){
      console.error(err);
    }
  }

}
